import React from 'react';
import styled from 'styled-components';
import SolutionSizeToggle from './SolutionSizeToggle';
import { useCore } from 'contexts/core';
import { Dimension, Product } from '@inter-ikea-storageone/range';
import { isMobile } from 'utils/platform';
import { changeSolutionSize } from 'rangeConfig/pax/utils/changeSize/changeSolutionSize';
import media from 'ui/media';
import { CheckWidget } from 'rangeConfig/shared/widgets/checkWidget';
import { useBehaviorTracker } from 'contexts/behaviors';
import { useServiceSettings } from 'contexts/serviceSettings';

const Wrapper = styled.div`
  width: 100%;
  ${media.mobile`
    padding: 0 1rem;
    display: flex;
    flex-direction: column;
    align-content: space-evenly;
  `}
  ${media.thinMobile`
    display: flex;
    flex-direction: column;
    align-content: space-evenly;
    padding: 0 0.5rem;
  `}
`;

type Props = CheckWidget & {
  dimension: Dimension;
  defaultSize?: number;
};

const ChangeSolutionSize = ({ ...props }: Props) => {
  const coreApi = useCore();
  const behaviorTracker = useBehaviorTracker();

  const handleSizeChange = (dimensionType: Dimension, size: number, products: Product[]) => {
    const meta = {
      size: {
        value: size,
        dimension: dimensionType
      }
    };

    behaviorTracker.withMeta(meta).custom(() => {
      changeSolutionSize(coreApi, dimensionType, size, products);
    });
  };

  return (
    <Wrapper>
      <SolutionSizeToggle
        defaultSize={props.defaultSize}
        showTitle={!isMobile()}
        dimensionType={props.dimension}
        onChangeSize={handleSizeChange}
        hideTab={props.hideTab}
      />
    </Wrapper>
  );
};

export const SolutionDepthToggle = (props: CheckWidget) => {
  return <ChangeSolutionSize dimension="depth" hideTab={props.hideTab} />;
};

export const SolutionHeightToggle = (props: CheckWidget) => {
  const { defaultFrameHeight } = useServiceSettings().dexfSettings.general;
  const defaultSize = parseInt(defaultFrameHeight, 10);

  return (
    <ChangeSolutionSize defaultSize={defaultSize} dimension="height" hideTab={props.hideTab} />
  );
};

export default ChangeSolutionSize;
